export default function routing($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.otherwise('');
    $stateProvider.state('App', {
        abstract: true,
        template: '<section ui-view></section>'
    });
}
routing.$inject = ['$urlRouterProvider', '$stateProvider'];
